import { useState } from 'react';
import { WORKERS_COMPENSATION_COVER } from '../../constants/coverage';
export var useValidationCheckForm = function useValidationCheckForm() {
  var _useState = useState(true),
      formPriceValid = _useState[0],
      setFormPriceValid = _useState[1];

  var checkValidationRequirementFormPriceValid = function checkValidationRequirementFormPriceValid(coverItem) {
    var isValid = true;

    if (coverItem !== null && coverItem !== void 0 && coverItem.useNewExtraction) {
      if (coverItem.cover_slug === WORKERS_COMPENSATION_COVER) {
        isValid = !!coverItem.statutory;
      } else {
        isValid = !!coverItem.amount || !!coverItem.limit_per_occurrence || !!coverItem.el_disease_each_employee || !!coverItem.el_disease_policy_limit;
      }
    } else {
      isValid = !!coverItem.amount;
    }

    setFormPriceValid(isValid);
    return isValid;
  };

  return {
    checkValidationRequirementFormPriceValid: checkValidationRequirementFormPriceValid,
    formPriceValid: formPriceValid,
    setFormPriceValid: setFormPriceValid
  };
};